export const titles = [
  { value: 'DR', label: 'Dr.' },
  { value: 'PROF', label: 'Prof.' },
  { value: 'PROF_DR', label: 'Prof Dr.' },
]
